module.exports = __webpack_public_path__ + "static/winner-sticker-f2fba7afe07d9ff80d5cff0c464294fc.webp";